import { createFlowAnalyticsTracker } from "../../utils/flowAnalytics/createFlowAnalyticsTracker.js";
import regFlowStepRegistry from "./regFlowStepRegistry.js";

export { FLOW_ANALYTICS_ACTIONS } from "../../utils/flowAnalytics/createFlowAnalyticsTracker.js";

export const createRegFlowAnalytics = ({
  getSearchId,
  getSteps,
  getFlowInstance,
  entryFlow = "reg",
}) =>
  createFlowAnalyticsTracker({
    getSearchId,
    getSteps,
    getFlowInstance,
    entryFlow,
    stepRegistry: regFlowStepRegistry,
  });
